import React, { ReactNode } from "react";
import { useAuthentication } from "@/contexts/AuthenticationContext";
import AuthenticatedOnly from "@/user/AuthenticatedOnly";

interface ConditionalStaffOnlyProps {
  children: ReactNode;
  showStaffView: boolean;
}

const ConditionalStaffOnly: React.FC<ConditionalStaffOnlyProps> = ({ children, showStaffView }) => {
  const { user } = useAuthentication();
  
  // Only show if user is staff AND showStaffView is true
  return user?.is_staff && showStaffView ? <>{children}</> : null;
};

const AuthenticatedAndConditionalStaffOnly: React.FC<ConditionalStaffOnlyProps> = ({ children, showStaffView }) => (
  <AuthenticatedOnly>
    <ConditionalStaffOnly showStaffView={showStaffView}>
      {children}
    </ConditionalStaffOnly>
  </AuthenticatedOnly>
)

export default AuthenticatedAndConditionalStaffOnly;
